///<reference path="../../../node_modules/primeng/components/tabview/tabview.d.ts"/>
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MisComponent} from './mis.component';
import {routing} from './mis.routing';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {MisService} from './mis.service';
import {Daterangepicker} from 'ng2-daterangepicker';
import {ChangeLanguageModule} from '../shared/change-language/change-language.module';
import {SharedTranslationModule} from '../shared/change-language/shared-translation.module';
import {NgxPaginationModule} from 'ngx-pagination';
import {LayoutModule} from '../layout/layout.module';
import {DashboardService} from '../configuration/dashboard/dashboard.service';
import {OpdAppoinmentService} from './mis-opd/opd-appointment/opd-appointment.service';
import {AutoCompleteModule, ConfirmDialogModule, DialogModule, DropdownModule, PanelModule, TabViewModule} from 'primeng/primeng';
import {NguiAutoCompleteModule} from '@ngui/auto-complete';
import {MstGenderService} from '../configuration/mst-gender/mst-gender.service';
import {MstMaritalStatusService} from '../configuration/mst-marital-status/mst-marital-status.service';
import {MstBloodgroupService} from '../configuration/mst-bloodgroup/mst-bloodgroup.service';
import {CollapseModule} from 'ngx-bootstrap';
import {MultiselectDropdownModule} from 'angular-2-dropdown-multiselect';
import { QualityIndicatorsComponent } from './quality-indicators/quality-indicators.component';
import {MbillTariffService} from '../configuration/mbill-tariff/mbill-tariff.service';


@NgModule({
    imports: [
        CommonModule,
        routing,
        ConfirmDialogModule,
        DialogModule,
        PanelModule,
        FormsModule,
        HttpModule,
        Daterangepicker,
        ReactiveFormsModule,
        SharedTranslationModule,
        ChangeLanguageModule,
        NgxPaginationModule,
        LayoutModule,
        AutoCompleteModule,
        NguiAutoCompleteModule,
        MultiselectDropdownModule,
        TabViewModule,
        CollapseModule,
        NguiAutoCompleteModule,

        DialogModule, DropdownModule
    ],
    declarations: [MisComponent],
    providers: [MisService, DashboardService, OpdAppoinmentService, MstGenderService, MstMaritalStatusService, MstBloodgroupService, MbillTariffService]
})
export class MisModule {
}







// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/mis/mis.module.ts